import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PaqueteSeguros} from '../_models/paquete-seguros';
import {GarantiasIdoneas} from '../_models/garantias-idoneas';
import {GarantiasIdoneasDestino} from '../_models/garantias-idoneas-destino';
import {GarantiasIdoneasProducto} from '../_models/garantias-idoneas-producto';
import {Observable} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class GarantiaIdoneasDestinosService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/garantiasIdoneasDestinosProductos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as GarantiasIdoneasDestino[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as GarantiasIdoneasDestino[] ) );
  }

  listadoPorDestinos(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id  ).pipe( map( res => res as GarantiasIdoneasDestino[] ) );
  }

  listadoPorDestinosActivos(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id  + '/enabled').pipe( map( res => res as GarantiasIdoneasDestino[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as GarantiasIdoneasDestino ) );
  }

  crear( regCrear: GarantiasIdoneasDestino ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as GarantiasIdoneasDestino ) );
  }

  actualizar( regActualizar: GarantiasIdoneasDestino ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( segmentoActividades: GarantiasIdoneasDestino[] ): Observable<GarantiasIdoneasDestino[]> {
    segmentoActividades.map( sa => {
      sa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', segmentoActividades ).pipe( map( res => res as GarantiasIdoneasDestino[] ) );
  }
}
